import { render, staticRenderFns } from "./softwareProduct.vue?vue&type=template&id=d483b3ba&scoped=true&"
import script from "./softwareProduct.vue?vue&type=script&lang=js&"
export * from "./softwareProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d483b3ba",
  null
  
)

export default component.exports